import { Component, OnInit, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SampleService } from '../../../core/http/sample.service';
import { Location } from '@angular/common';
import { RefundReceiptModalComponent } from '../refund-receipt-modal/refund-receipt-modal.component';

@Component({
  selector: 'app-refund',
  templateUrl: './refund.component.html',
  styleUrls: ['./refund.component.scss'],
})
export class RefundComponent implements OnInit {
  isLoading = false;
  message: any = [];
  serviceAmount = 0;
  @Input() data;
  // @Input() info;

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    private sample: SampleService,
    private location: Location
  ) {
    // this.stateForm = new FormGroup({
    //   refund_date: new FormControl(new Date()), // Set the current date here
    // });
    this.serviceAmount = this.data?.amount;
  }

  ngOnInit(): void {
    console.log(this.data);
    this.serviceAmount = this.data?.amount;
    console.log(this.serviceAmount);
    this.stateForm.patchValue({
      refund_amount: this.serviceAmount,
    });
  }

  stateForm = new FormGroup({
    payment_mode: new FormControl(''),
    payment_ref: new FormControl(''),
    payment_date: new FormControl(''),
    service_code: new FormControl(0),
    refund_date: new FormControl(new Date()),
    refund_amount: new FormControl(this.serviceAmount),
    refund_reason: new FormControl(''),
  });

  openIt() {
    const info = {
      bill_no: this.data.bill_no,
      bill_Id: this.data.bill_id,
    };
    this.modal.closeModal();
    this.modal.openModal(RefundReceiptModalComponent, 'modal', info);
  }

  Submit(e) {
    e.preventDefault();
    this.isLoading = true;
    const receipt_no = this.data.receipt_no;
    const receipt_id = this.data.receipt_id;
    const bill_id = this.data.bill_id;
    const payment_mode = this.data.payment_mode;
    const payment_date = this.data.payment_date;
    const service_codes = this.data.sample_ids || [];
    const amount = this.data.amount;
    // const bill_no = this.data.bill_no;
    const {
      payment_ref,
      service_code,
      refund_date,
      refund_amount,
      refund_reason,
    } = this.stateForm.value;
    if (refund_amount > amount) {
      this._snackBar.open(
        'Refund Amount cannot be greater than service amount',
        '',
        {
          duration: 2000,
          verticalPosition: 'top',
        }
      );
      this.isLoading = false;
    } else {
      this.sample
        .refundPayment(
          payment_mode,
          payment_ref,
          payment_date,
          service_code,
          refund_date,
          receipt_no,
          receipt_id,
          bill_id,
          refund_amount,
          refund_reason,
          service_codes
        )
        .subscribe(
          (resSuccess) => {
            this.message = resSuccess;
            this.isLoading = false;
            console.log(resSuccess);

            this.stateForm.reset();

            if (this.message.success) {
              // this.modal.closeModal();
              this._snackBar.open('Refund Successfully', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
              // location.reload();
              this.openIt();
            } else {
              console.log('Error Please Try Agian');
              this._snackBar.open('Error Please Try Agian', '', {
                duration: 2000,
                verticalPosition: 'top',
              });
            }
          },
          (resErr) => {
            this.isLoading = false;
            console.log(resErr);
          }
        );
    }
  }
}
